"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomerSourceModel = /** @class */ (function () {
    function CustomerSourceModel($http, APPURL) {
        this.$http = $http;
        this.URLS = {
            FETCH: APPURL + "/api/v1/marketing/customer-sources",
            UPDATE: APPURL + "/api/v1/marketing/customer-sources",
            CREATE: APPURL + "/api/v1/marketing/customer-sources",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    CustomerSourceModel.prototype.extract = function (result) {
        return result.data;
    };
    CustomerSourceModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    CustomerSourceModel.prototype.getCustomerSourceByID = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    CustomerSourceModel.prototype.getCustomerSources = function () {
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    CustomerSourceModel.prototype.createCustomerSource = function (request) {
        return this.$http
            .post(this.URLS.FETCH, request)
            .then(this.cacheResults);
    };
    CustomerSourceModel.prototype.removeCustomerSource = function (cs) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + cs.id)
            .then(this.cacheResults);
    };
    return CustomerSourceModel;
}());
CustomerSourceModel.$inject = ["$http", "APPURL"];
exports.default = CustomerSourceModel;
